module.exports = __webpack_public_path__ + "img/keyboard.be5030ca.webp";